import { Navigation } from "../../interfaces/Navigation";
import { PermissionMenuName } from "../../interfaces/UserRole";

const navSistemKerjasama: Navigation = {
  title: 'Sistem Kerjasama',
  items: [
    {
      title: "Dokumen Kerjasama",
      route: "/dokumen-kerjasama",
      icon: "fa fa-file",
      permissionId: PermissionMenuName.dokumenKerjasama
    },
  ]
};

export default navSistemKerjasama